import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { EOtpremniceClient, TipOtpremnice } from '@kodit/core/data-api';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-tip-otpremnice-dropdown',
  templateUrl: './tip-otpremnice-dropdown.component.html',
  styleUrls: ['./tip-otpremnice-dropdown.component.scss']
})
export class TipOtpremniceDropdownComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();

  /** Props */
  items: SelectItem[] = [];

  /** I/O */
  @Input() formCtrl: AbstractControl;
  @Input() formCtrlId: string;
  @Input() parentCtrl: any = 'body';
  @Output() onItemChange = new EventEmitter<TipOtpremnice>();

  constructor(
    private _client : EOtpremniceClient,
  ) { }

  ngOnInit(): void {
    this._load();
  }

  private async _load() {
    this._subs.add(
      this._client.getTipOtpremnice().subscribe((res) => {
        this.items = res.data!.tipOtpremniceList!.map((x) => ({
          value: x.tip,
          label: x.tipStr,
          title: x.opis,
        }));
      })
    );
  }

  handleOnItemChange(event: any) {
    this.onItemChange.emit(event.value);
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
